import { useFragmentContext } from '@jsmdg/react-fragment-scripts/fragment';
import { type FooterContext } from '../types';

interface FeatureFlagsVariation {
    isNewDesign: boolean;
}

export const useFeatureFlagsVariations = (): FeatureFlagsVariation => {
    const { featureFlagsVariation } = useFragmentContext<FooterContext>();

    return {
        isNewDesign: featureFlagsVariation?.checkout_improvement === 'on',
    };
};
